import HologramCard from '../../../components/base/HologramCard';
import GlitchText from '../../../components/base/GlitchText';

export default function ContactSection() {
  return (
    <section id="contact" className="min-h-screen py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white font-orbitron mb-4">
            <GlitchText text="POWER CORE" />
          </h2>
          <div className="text-xl text-red-400 font-mono mb-2">ENERGY DISTRIBUTION SYSTEM</div>
          <p className="text-gray-400 font-rajdhani text-lg">Establish connection protocols and data transmission</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Contact Info */}
          <HologramCard glowColor="cyan">
            <h3 className="text-xl font-bold text-white font-orbitron mb-4 flex items-center">
              <i className="ri-map-pin-line text-cyan-400 mr-3"></i>
              LOCATION COORDINATES
            </h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-building-line text-cyan-400"></i>
                <span className="text-gray-300 font-rajdhani">KIIT University, Bhubaneswar</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-global-line text-cyan-400"></i>
                <span className="text-gray-300 font-rajdhani">Odisha, India</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-zone-line text-cyan-400"></i>
                <span className="text-gray-300 font-rajdhani">IST (UTC +5:30)</span>
              </div>
            </div>
          </HologramCard>

          <HologramCard glowColor="green">
            <h3 className="text-xl font-bold text-white font-orbitron mb-4 flex items-center">
              <i className="ri-links-line text-green-400 mr-3"></i>
              NETWORK CONNECTIONS
            </h3>
            <div className="space-y-4">
              <a 
                href="https://www.linkedin.com/in/adityaprakash0302/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors group"
              >
                <i className="ri-linkedin-line text-green-400 group-hover:scale-110 transition-transform"></i>
                <span className="font-rajdhani">LinkedIn Profile</span>
                <i className="ri-external-link-line text-xs"></i>
              </a>
              <a 
                href="https://github.com/AdityaPrakash-03"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors group"
              >
                <i className="ri-github-line text-green-400 group-hover:scale-110 transition-transform"></i>
                <span className="font-rajdhani">GitHub Repository</span>
                <i className="ri-external-link-line text-xs"></i>
              </a>
              <a 
                href="https://x.com/Adi_03_02"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-300 hover:text-green-400 transition-colors group"
              >
                <i className="ri-twitter-x-line text-green-400 group-hover:scale-110 transition-transform"></i>
                <span className="font-rajdhani">Twitter/X Handle</span>
                <i className="ri-external-link-line text-xs"></i>
              </a>
            </div>
          </HologramCard>

          <HologramCard glowColor="orange">
            <h3 className="text-xl font-bold text-white font-orbitron mb-4 flex items-center">
              <i className="ri-calendar-line text-orange-400 mr-3"></i>
              AVAILABILITY STATUS
            </h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-green-400 font-rajdhani font-semibold">ONLINE</span>
              </div>
              <div className="text-gray-300 font-rajdhani text-sm">
                Available for product management opportunities and collaborations
              </div>
            </div>
          </HologramCard>
        </div>

        {/* Final Call to Action */}
        <div className="text-center mt-20">
          <div className="text-3xl font-bold text-red-400 font-orbitron animate-pulse">
            "Hire me before someone smarter does."
          </div>
        </div>
      </div>
    </section>
  );
}
